<template>
  <div class="lang">
    <div>
      <span
        v-bind:class="{ selected: selected == 'fa' }"
        @click="changeLocale(0)"
        >FA</span
      >
      /
      <span
        v-bind:class="{ selected: selected == 'en' }"
        @click="changeLocale(1)"
        >EN</span
      >
    </div>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
export default {
  data() {
    return {
      selected: "fa",
      languages: [
        { dir: "rtl", language: "fa", title: "persian" },
        { dir: "ltr", language: "en", title: "English" }
      ]
    };
  },
  methods: {
    changeLocale(languageIndex) {
      i18n.locale = this.languages[languageIndex].language;
      document.body.dir = this.languages[languageIndex].dir;
      this.selected = this.languages[languageIndex].language;
    }
  }
};
</script>
<style>
.lang {
  position: relative;
}

.lang span {
  cursor: pointer;
}

.lang .selected {
  font-weight: bold;
  color: #ff0000;
}
</style>
